<template>
  <b-modal ref="delete-attachment-modal" hide-footer @hide="hideModal">
    <div class="d-block text-center">
      <h4 qid="delete-s-title">
        {{ $t('attachments.delete.title') }}
      </h4>
    </div>
    <h5 class="text-center">
      <span v-if="type == 'file'">
        {{ $t('attachments.delete.are_you_sure_file') }}
      </span>
      <span v-if="type == 'linked_file'">
        {{ $t('attachments.delete.are_you_sure_file') }}
      </span>
      <span v-if="type == 'comment'">
        {{ $t('attachments.delete.are_you_sure_comment') }}
      </span>
      <span v-if="type == 'link'">
        {{ $t('attachments.delete.are_you_sure_link') }}
      </span>
    </h5>
    <div class="text-center">
      <b-button class="mt-3"
                variant="secondary"
                @click="handleCancelButton"
                qid="delete-attachment-cancel-button"
      >
        {{ $t('attachments.delete.cancel') }}
      </b-button>
      <b-button @click="removeMediaItem()"
                class="mt-3 ml-3"
                variant="success"
                qid="delete-attachment-submit-button"
      >
        {{ $t('attachments.delete.submit') }}
      </b-button>
    </div>
  </b-modal>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'ConfirmRemoveAttachment',
    data: function() {
      return {
        error: '',
        processGroup: [],
        showInput: false,
        loadingItems: false,
        showArticleDescription: false
      }
    },
    props: {
      object: {
        type: Object
      },
      show: {
        type: Boolean
      },
      task: {},
      type: {}
    },
    components: {

    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when prop changes
      show: function (value) {
        if (value) {
          this.showModal()
        }
      }
    },
    methods: {
      removeMediaItem() {
        let self = this;
        if (this.type == 'file') {
          piincHttp.delete('documents/' + this.object.id).then(function () {
            self.handleCancelButton()
            // Trigger toastr message after document is removed
            self.$toastr('success', self.$t('maintenance.third_parties.media_delete_success'))
          }, function () {
          })
        } else if (this.type == 'linked_file') {
          piincHttp.delete('tasks/' + this.task.id + '/linked-media/' + this.object.id).then(function() {
            self.handleCancelButton()
            // Trigger toastr message after document is removed
            self.$toastr('success', self.$t('maintenance.third_parties.media_delete_success'))
          }, function() {})
        } else if (this.type == 'comment') {
          piincHttp.delete('tasks/' + this.task.id + '/comments/' + this.object.id).then(function() {
            self.handleCancelButton()
            // Trigger toastr message after document is removed
            self.$toastr('success', self.$t('maintenance.third_parties.comment_delete_success'))
          }, function() {})
        } else {
          piincHttp.delete('links/' + this.object.id).then(function() {
            self.handleCancelButton()
            self.$toastr('success', self.$t('maintenance.third_parties.link_delete_success'))
          }, function() {})
        }

      },
      showModal() {
        let self = this
        this.$refs['delete-attachment-modal'].show()
      },
      hideModal() {
        this.error = ''
        this.$emit('closeConfirmModal');
        this.$refs['delete-attachment-modal'].hide()
      },
      handleCancelButton() {
        this.$refs['delete-attachment-modal'].hide()
      }
    },
    created () {

    }
  }
</script>
